import Curd from "./Curd";
export default class App extends Curd {
    BASE_PATH = "/app"    
}